import { render, staticRenderFns } from "./ProgressbarFooter.vue?vue&type=template&id=04b60166&scoped=true"
import script from "./ProgressbarFooter.vue?vue&type=script&lang=js"
export * from "./ProgressbarFooter.vue?vue&type=script&lang=js"
import style0 from "./ProgressbarFooter.vue?vue&type=style&index=0&id=04b60166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b60166",
  null
  
)

export default component.exports